import { useAnalytics } from "@/src/sb/components/Analytics"
import { AnalyticsService } from "@/src/sb/components/Analytics/AnalyticsService"
import { useEffect, useRef } from "react"

const useFlourishScript = (
  autoRenderCharts?: boolean,
  dependencies?: Array<unknown>
) => {
  const analytics = useAnalytics()
  const flourish = useRef<any>()
  const animationFrameID = useRef<number | null>()
  const maxRetries = useRef<number>(15)
  const retryCount = useRef<number>(0)

  function renderCharts() {
    const embeds = document.querySelectorAll("div.flourish-embed")

    if (embeds.length > 0) {
      embeds.forEach((embed) => {
        if (!embed.querySelector("iframe")) {
          flourish.current.loadEmbed?.(embed)
        }
      })

      return
    }

    retryCount.current++
    if (retryCount.current >= maxRetries.current) return
    animationFrameID.current = requestAnimationFrame(renderCharts)
  }

  function destroyCharts() {
    if (animationFrameID.current) cancelAnimationFrame(animationFrameID.current)

    document
      .querySelectorAll("div.flourish-embed > iframe")
      .forEach((iframe) => {
        iframe.remove()
      })
  }

  useEffect(() => {
    flourish.current = (window as any).Flourish
    if (!flourish.current) return
    flourish.current.addAnalyticsListener(
      analytics?.trackFlourishInteraction.bind(AnalyticsService)
    )

    return () =>
      flourish.current.removeAnalyticsListener(
        analytics?.trackFlourishInteraction
      )
  }, [])

  useEffect(() => {
    if (!autoRenderCharts || !flourish.current) return
    renderCharts()

    return () => {
      destroyCharts()
    }
  }, dependencies)

  return {
    renderCharts,
    destroyCharts
  }
}

export default useFlourishScript
